// Make API call to check login status and refresh tokens if need be.
export const fetchLoginStatus = async () =>
  fetch("/api/check-login-status-and-refresh", {
    method: "POST",
  });
